import { useReactiveVar } from "@apollo/client";
import { isNewDashboardVar } from "./../graphql/cache";

type useNewDashboardReturnType = {
  isNewDashboard: boolean;
};

export const useNewDashboard = (): useNewDashboardReturnType => {
  const isNewDashboard = useReactiveVar(isNewDashboardVar);

  return { isNewDashboard };
};
